// Master flag for all preparer functionality; off in prod/prodtest.
export function isPreparerEnabled () {
	try {
		return JSON.parse(process.env.VUE_APP_PREPARER_ENABLED) === true
	} catch {
		return false
	}
}

export function isPreparerContext () {
	if (!isPreparerEnabled()) return false
	const redirectUri = sessionStorage.getItem('redirect_uri')
	return redirectUri?.includes('preparer') ?? false
}

export function isPreparerLinkContext () {
	if (!isPreparerEnabled()) return false
	return sessionStorage.getItem('redirect_uri') === 'preparer_link'
}
